export default "__VITE_ASSET__D8fDD9Rp__"